export default "__VITE_ASSET__GWWl9gg5__"